import Vue from 'vue';
import { Message } from 'element-ui';

// 防抖
function debounce(fun, delay) {
  let timer;
  return function () {
    if (timer) clearTimeout(timer);
    let args = arguments;
    timer = setTimeout(() => {
      fun.apply(this, args);
    }, delay);
  };
}

// 检查对象是否为空
const isEmptyObject = obj => {
  return Object.keys(obj).length === 0;
};

// 格式化数据
const format = {
  phone(phone) {
    let value = '-';
    if (phone) {
      let start = phone.substr(0, 3);
      let end = phone.substr(7);
      value = start + '****' + end;
    }

    return value;
  },
  flow(value) {
    let res = value || 0;
    if ((value + '').indexOf('.') !== -1) {
      let data = (value + '').split('.');
      let before = data[0];
      let after = data[1].substr(0, 2);
      res = `${before}.${after}`;
    }
    if (res <= 0) {
      res = 0;
    }
    return res;
  },
  toFixed(value, length = 2) {
    let res = value || 0;
    if ((value + '').indexOf('.') !== -1) {
      let data = (value + '').split('.');
      let before = data[0];
      let after = data[1].substr(0, length);
      res = `${before}.${after}`;
    }
    res = Number(res);
    return res;
  },
  date(value) {
    let res = '-';
    if (value) {
      res = value.replace('T', ' ').split('+')[0];
    }
    return res;
  },
  dateOrigin(value) {
    let res = '-';
    if (value) {
      if (value.includes('0001-01-01')) {
        res = '-';
      } else {
        res = value.replace('T', ' ').split('+')[0];
      }
    }

    return res;
  }
};

// 表单校验
const validate = {
  mobileRequired: (rule, value, cb) => {
    if (value) {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        cb(new Error('请输入正确的手机号'));
      } else {
        cb();
      }
    } else {
      cb(new Error('请输入'));
    }
  },
  mobile: (rule, value, cb) => {
    if (value) {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!reg.test(value)) {
        cb(new Error('请输入正确的手机号'));
      } else {
        cb();
      }
    } else {
      cb();
    }
  },
  email: (rule, value, cb) => {
    if (value) {
      let reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      if (!reg.test(value)) {
        cb(new Error('请输入正确的邮箱账号'));
      } else {
        cb();
      }
    } else {
      cb();
    }
  },
  account: (rule, value, cb) => {
    if (value) {
      let reg = /^[a-zA-Z0-9]+$/;
      if (!reg.test(value)) {
        cb(new Error('账号仅支持英文和数字'));
      } else {
        cb();
      }
    } else {
      new Error('请输入');
    }
  },
  name: (rule, value, cb) => {
    if (value) {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+$/;
      if (reg.test(value)) {
        cb();
      } else {
        cb(new Error(rule.message));
      }
    }
  },
  flag: (rule, value, cb) => {
    if (value) {
      const reg = /^[a-zA-Z0-9]([a-zA-Z0-9_.#]{1,20})$/;
      if (reg.test(value)) {
        cb();
      } else {
        cb(new Error(rule.message));
      }
    }
  }
};

// 时间格式化
function dateFormatter(date = '', type = 1) {
  const time = date === '' ? new Date() : new Date(date);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1 + '').padStart(2, '0');
  const day = (time.getDate() + '').padStart(2, '0');
  const hour = (time.getHours() + '').padStart(2, '0');
  const minute = (time.getMinutes() + '').padStart(2, '0');
  const second = (time.getSeconds() + '').padStart(2, '0');
  const msecond = (time.getMilliseconds() + '').padStart(3, '0');
  let dateFormatter = '';
  switch (type) {
    case 1:
      dateFormatter = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      break;
    case 2:
      dateFormatter = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      break;
    case 3:
      dateFormatter = `${year}-${month}-${day} ${hour}:${minute}`;
      break;
    case 4:
      dateFormatter = `${year}-${month}-${day} 00:00`;
      break;
    case 5:
      dateFormatter = `${year}-${month}-${day} ${hour}:${minute}:${second}.${msecond}`;
      break;
    case 6:
      dateFormatter = `${year}-${month}-${day}`;
      break;
    case 7:
      dateFormatter = `${year}${month}${day}`;
      break;
    case 8:
      dateFormatter = `${month}-${day}`;
      break;
    case 9:
      dateFormatter = `${month}-${day} ${hour}:${minute}`;
      break;
    case 10:
      dateFormatter = `${hour}:${minute}:${second}`;
      break;
    case 11:
      dateFormatter = `${year}${month}`;
      break;
  }
  return dateFormatter;
}

// js 复制到剪贴板
const copy = content => {
  // for ie
  if (window.clipboardData) {
    window.clipboardData.clearData();
    window.clipboardData.setData('text', content);
  } else if (document.execCommand) {
    // for modern browser
    let element = document.createElement('SPAN');
    element.textContent = content;
    document.body.appendChild(element);
    if (document.selection) {
      let range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      let range = document.createRange();
      range.selectNode(element);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
    document.execCommand('copy');
    element.remove ? element.remove() : element.removeNode(true);
  }

  Message({
    type: 'success',
    message: '已复制'
  });
};

Vue.prototype.$isEmptyObject = isEmptyObject;
Vue.prototype.$format = format;
Vue.prototype.$validate = validate;
Vue.prototype.$dateFormatter = dateFormatter;
Vue.prototype.$copy = copy;
